<div
  class="authentication__right__card__field authentication__right__card__field--with-margin"
  fxLayout="column"
  fxLayoutAlign="center stretch"
  fxLayoutGap="8px"
>
  <label class="authentication__right__card__field-label"> {{ 'LOGIN.AUTH.EMAIL.INPUT' | translate }} </label>
  <div class="authentication__right__card__field__input-box">
    <input
      class="authentication__right__card__field__input-box_input"
      type="email"
      name="email"
      autocomplete="email"
      autofocus
      [formControl]="loginForm.controls['email']"
      [placeholder]="'LOGIN.AUTH.PLACEHOLDER' | translate"
    />
  </div>
  <div *ngIf="!loginForm.get('email').pristine && loginForm.get('email').touched && loginForm.get('email').invalid">
    <small class="authentication__right__card__field-error" *ngIf="loginForm.get('email').hasError('required')">
      {{ 'LOGIN.AUTH.ERRORS.REQUIRED_EMAIL' | translate }}
    </small>
    <small
      class="authentication__right__card__field-error"
      *ngIf="loginForm.get('email').hasError('email') || loginForm.get('email').hasError('pattern')"
    >
      {{ 'LOGIN.AUTH.ERRORS.INVALID_EMAIL' | translate }}
    </small>
  </div>
</div>

<button
  class="authentication__right__card_next mt-22"
  data-cy="next-to-password"
  mat-raised-button
  [disabled]="loginForm.get('email').invalid || isLoading"
  (click)="toPasswordStep.next()"
>
  {{ 'LOGIN.AUTH.NEXT' | translate }}
</button>
